import { client } from '@/lib/apollo-client';
import { DROPBOX_VIDEO_METADATA } from '@/queries/dropbox';
import type { DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables } from '@/generated/dropbox';
import type { VideoMetadata } from '@/lib/video-metadata';
import { getDropboxErrorCode } from './errors';
import { validateDropboxFileLink } from './links';

export async function getDropboxVideoMetadata(url: string): Promise<VideoMetadata> {
  validateDropboxFileLink(url);
  try {
    const result = await client.query<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>({
      query: DROPBOX_VIDEO_METADATA,
      variables: { url },
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
    if (result.error || result.errors?.length) throw new Error(getDropboxErrorCode(result) ?? 'DROPBOX_UNAVAILABLE');
    const data = result.data?.dropboxVideoMetadata;
    if (!data || typeof data.title !== 'string' || !data.title.trim()
      || ![data.duration, data.width, data.height, data.source_size_bytes].every((value) => typeof value === 'number' && Number.isFinite(value) && value > 0)
      || !Number.isInteger(data.width) || !Number.isInteger(data.height)) throw new Error('DROPBOX_UNAVAILABLE');
    // The share URL is submission input only. No source formats or thumbnails
    // are exposed to browser media elements or the CORS proxy.
    return {
      title: data.title, duration: data.duration, width: data.width, height: data.height,
      source_size_bytes: data.source_size_bytes, platform: 'dropbox', url, live_status: 'not_live',
    };
  } catch (error) {
    throw new Error(getDropboxErrorCode(error) ?? 'DROPBOX_UNAVAILABLE');
  }
}
